import ServicePrices from '../pages/ServicePrices.vue';

const servicePricesRoutes = [
  {
    path: '/financial-management/service-prices',
    name: 'محاسبات شارژ اعتبار',
    component: ServicePrices,
    meta: {
      roles: ['merchant', 'supplier'],
    },
  },
];
export default servicePricesRoutes;
